import { Card, Checkbox, Menu } from "antd";
import { useSupplyStore } from "./supply.store";
import { StatusStock, SuppliesType } from "~/utils/constants";
import { capitalize } from "~/utils";
import { useEffect, useState } from "react";

export const SidebarSupplies = () => {
  const [type, setType] = useState<SuppliesType | "all">("all");
  const { filters, setFilters } = useSupplyStore();

  useEffect(() => {
    setFilters({ suppliesType: type === "all" ? ("" as SuppliesType) : type });
  }, [type, setFilters]);

  return (
    <Card
      classNames={{
        body: "p-0",
      }}
    >
      <h3 className="font-medium p-4 border-b">Categories</h3>
      <Menu
        defaultSelectedKeys={["all"]}
        className="p-2 border-r-0"
        selectedKeys={[type]}
        onClick={(e) => setType(e.key as SuppliesType)}
        items={[
          { key: "all", label: "All Supplies" },
          ...Object.values(SuppliesType).map((type) => ({
            key: type,
            label: capitalize(type),
          })),
        ]}
      />
      <div className="p-4 border-t">
        <Checkbox
          checked={filters.statusStock === StatusStock.LOW_STOCK}
          onChange={(e) =>
            setFilters({
              statusStock: e.target.checked
                ? StatusStock.LOW_STOCK
                : StatusStock.NOT_LOW_STOCK,
            })
          }
        >
          Show Low Stock Only
        </Checkbox>
      </div>
    </Card>
  );
};
